export default __webpack_public_path__ + "static/Varias03-92e4fe82a362214554476a192f8415ab.svg";